<template>
 <a href="#"
                class="group flex flex-col items-center justify-between p-2 rounded-lg transition duration-150 ease-in-out hover:bg-gray-50"
                @click="loadModalRangoFechas(true)">
                <div
                  class="flex-shrink-0 inline-flex h-11 w-11 sm:h-10 sm:w-10 items-center justify-center rounded-md bg-indigo-500 text-white">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="w-8 h-8">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 6v6l4 2m6-2a10 10 0 11-20 0 10 10 0 0120 0z" />
                  </svg>

                </div>
                <p class="text-xs text-gray-900"> {{ $t('horas') }}</p>
              </a>

     
</template>

<script>
export default {
    name: 'btnMapa',
    emits: ['emitModalEditHorasGlobal'],
    methods: {
        loadModalRangoFechas() {
            this.$emit('emitModalEditHorasGlobal')
        }
    }
}
</script>